<!-- product-nav.component.html -->
 <div class="product-nav" (mouseleave)="onNavMouseLeave()">
  <div class="category-container">

    <button class="nav-btn left" (click)="scrollLeft()">‹</button>

    <ul class="category-list" #categoryList>
      <li *ngFor="let category of categories"
          class="category-item"
          (mouseenter)="onCategoryMouseEnter(category, categoryEl)"
           >

        <a class="category-link">{{ category.name }}</a>

      </li>
    </ul>

    <button class="nav-btn right" (click)="scrollRight()">›</button>

  </div>

  <!-- 🔥 MOVE OUTSIDE UL -->
  <div class="mega-menu"
       *ngIf="activeCategory && activeCategory.subcategories?.length">

    <div class="mega-menu-grid">
      <div *ngFor="let sub of activeCategory.subcategories">
        <a [routerLink]="['/subcategory', sub.id]">{{ sub.name }}</a>
      </div>
    </div>

  </div>
</div>

<!-- Mobile Menu -->
<div class="mobile-menu d-lg-none">
  <div class="container">
    <div class="mobile-menu-header d-flex justify-content-between align-items-center py-2">
      <div class="logo">
        <a routerLink="/">
          <img src="assets/img/ufp_logo8.png" alt="Union Firce Protection" style="width: auto; height: 50px;">
        </a>
      </div>
      <div class="products-add-to-cart me-3">
        <button type="submit" class="default-btn header-enquire-btn"
          style="background: linear-gradient(to right, #FFD700, #DC1E28); color: #ffffff;
          padding: 5px 13px 5px 42px;
          font-size: 12px;
          border-radius: 5px;
          margin-top: 4%;" 
          data-bs-toggle="modal" data-bs-target="#enquireModal">
          <i class='bx bxs-paper-plane'></i> Enquire
        </button>
      </div>
      <div class="mobile-icons d-flex align-items-center">
       
        <button class="menu-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#mobileMenuContent">
          <i class='bx bx-menu'></i>
        </button>
      </div>
    </div>

    <div class="collapse" id="mobileMenuContent">
      <ul class="mobile-nav-list list-unstyled p-3">
        <li><a routerLink="/home" class="nav-link">Home</a></li>
		<li><a routerLink="/gallery" class="nav-link">Products</a></li>
        <li><a routerLink="/showroom-gallery" class="nav-link">Showroom gallery</a></li>
        <li><a routerLink="/about" class="nav-link">About</a></li>
        <li><a routerLink="/contact" class="nav-link">contact us</a></li>
        <!-- Categories with Subcategories -->
        <li *ngFor="let category of categories" class="nav-item category-item position-relative">
          <div class="category-link-wrapper d-flex justify-content-between align-items-center" (click)="category.expanded = !category.expanded">
            <a [routerLink]="" [queryParams]="{ name: category.name }" class="nav-link">
              {{ category.name }}
            </a>
            <i class="bx bx-chevron-down"></i>
          </div>

          <!-- Subcategories -->
          <ul class="subcategory-list list-unstyled ps-3" [class.show]="category.expanded">
            <li *ngFor="let subcategory of category.subcategories" class="subcategory-item">
              <a [routerLink]="['/subcategory', subcategory.id]" [queryParams]="{ name: subcategory.name }" class="subcategory-link">
                {{ subcategory.name }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>

